const creativeProjects = [
  {
    text: 'Particle Font',
    image: require('../../images/creative projects/particle_font.png'),
    demoLink: 'https://eansengchang.github.io/Particle-Font/',
    codeLink: 'https://github.com/eansengchang/Particle-Font',
  },
  {
    text: 'Flocking Simulation',
    image: require('../../images/creative projects/flocking_simulation.png'),
    demoLink: 'https://eansengchang.github.io/Flocking-Simulation/',
    codeLink: 'https://github.com/eansengchang/Flocking-Simulation',
  },
  {
    text: 'Evolution Steering',
    image: require('../../images/creative projects/evolution_steering.png'),
    demoLink: 'https://eansengchang.github.io/Evolution-Steering/',
    codeLink: 'https://github.com/eansengchang/Evolution-Steering',
  },
  {
    text: 'A* Visualised',
    image: require('../../images/creative projects/Astar_visualiser.png'),
    demoLink: 'https://eansengchang.github.io/A-star-pathfinding/',
    codeLink: 'https://github.com/eansengchang/A-star-pathfinding',
  },
  {
    text: 'Circle Images',
    image: require('../../images/creative projects/circle_images.png'),
    demoLink: 'https://eansengchang.github.io/Circle-Images/',
    codeLink: 'https://github.com/eansengchang/Circle-Images',
  },
  {
    text: 'Particle Clock',
    image: require('../../images/creative projects/particle_clock.png'),
    demoLink: 'https://eansengchang.github.io/Particle-Clock/',
    codeLink: 'https://github.com/eansengchang/Particle-Clock',
  },
  {
    text: 'Phase Portrait Visualiser',
    image: require('../../images/creative projects/phase_portrait.png'),
    demoLink: 'https://eansengchang.github.io/Phase-Portrait-Visualiser/',
    codeLink: 'https://github.com/eansengchang/Phase-Portrait-Visualiser',
  },
];

export default creativeProjects;
